import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { SystemFlow } from './SystemFlow';
import { getWhatsAppLink } from '../../utils/whatsapp';
const HERO_WHATSAPP_MESSAGE = 'Hola, equipo de Origen Studio. Quiero construir mi sistema digital.';
export function Hero() {
  return <section className="min-h-[100vh] pt-[72px] bg-arena flex items-center" data-id="element-144" data-mp="eplz7hr3rz25">
      <div className="max-w-[1200px] mx-auto w-full px-6 md:px-20 py-14 md:py-0" data-id="element-145" data-mp="apl92zun5zf9">
        <div className="grid grid-cols-1 md:grid-cols-[55%_45%] gap-16 md:gap-8 items-center min-h-[calc(100vh-72px)]" data-id="element-146" data-mp="5oxigfabrklk">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="flex flex-col items-start" data-id="element-147" data-mp="qm9e6rute4e">
            <span className="font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-148" data-mp="1mw2vhfhzaq7r">
              ORIGEN / DIGITAL SYSTEMS
            </span>

            <h1 className="font-display text-[40px] md:text-[64px] font-bold text-carbon leading-[1.08] tracking-[-0.02em] max-w-[560px] mb-6" data-id="element-149" data-mp="1cy6bdy72ckxi">
              Tu presencia digital debería trabajar por tu empresa.
            </h1>

            <p className="font-body text-[18px] md:text-[20px] text-carbon/65 leading-[1.6] max-w-[480px] mb-8" data-id="element-150" data-mp="25mk8mbqbvd80">
              Construimos presencia digital y sistemas de IA que atienden,
              califican, venden, agendan y hacen seguimiento.
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto mb-8" data-id="element-151" data-mp="20w3wcuy8txn8">
              <a href={getWhatsAppLink(HERO_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-verde text-arena font-display font-semibold text-[15px] px-7 py-3.5 rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta active:translate-y-0 transition-all duration-200" data-id="element-152" data-mp="2oly796z05c4u">
                Construir mi sistema <ArrowRight size={16} className="ml-2" data-id="element-153" data-mp="2u5vsl18zuffw" />
              </a>
              <a href="#como-funciona" className="inline-flex items-center justify-center bg-transparent text-carbon border border-carbon/20 font-display font-semibold text-[15px] px-7 py-3.5 rounded-[6px] hover:border-carbon/40 hover:bg-carbon/5 transition-all duration-200" data-id="element-154" data-mp="2p7kkow29ef0b">
                Ver cómo funciona <ChevronDown size={16} className="ml-2" data-id="element-155" data-mp="2ahd82wyxnq7j" />
              </a>
            </div>

            <p className="font-body text-[13px] text-carbon/40 tracking-wide" data-id="element-156" data-mp="26g1i2qc5d2yt">
              Web · WhatsApp · IA · CRM · Agenda · Voice
            </p>
          </motion.div>

          {/* Right Column - Interactive system diagram */}
          <div className="w-full flex items-center justify-center" data-id="element-157" data-mp="c2fga4c4hlk3">
            <SystemFlow data-id="element-158" data-mp="c4a1zkv7xhp8" />
          </div>
        </div>
      </div>
    </section>;
}